// mj-social-element defaults to _blank and the render drops an empty target,
// so a missing or empty target still opens in a new tab and reads as ON.
export const socialTargetAdapter = {
	format(val?: string) {
		return val === undefined || val === '' || val === '_blank';
	},
	parse(val: boolean) {
		return val ? '_blank' : '_self';
	},
};
